import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class CppReturnAddProductSliderModelService {
  public addcppReturnProductSlider: BehaviorSubject<boolean>;
  public cppReturnSidenav: MatSidenav;
  private activeSliderValue: string;
  cppReturnSliderCloseRqt: Subject<boolean>;
  cppReturnModelData: BehaviorSubject<any>;

  constructor() {
    this.addcppReturnProductSlider = new BehaviorSubject(false);
    this.cppReturnModelData = new BehaviorSubject(EMPTY);
    this.cppReturnSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'AddCppReturnProductSlider') {
      this.addcppReturnProductSlider.next(true);
      this.cppReturnModelData.next(EMPTY);
      this.cppReturnSidenav.toggle();
    }
  }

  public setCppReturnSideNav(cppReturnSideNavObj: MatSidenav) {
    this.cppReturnSidenav = cppReturnSideNavObj;
  }

  public cppReturnClose() {
    this.cppReturnModelData.next(EMPTY);
    this.addcppReturnProductSlider.next(false);
    this.cppReturnSidenav.close();
  }

  public setData<T>(obj: T) {
    this.cppReturnModelData.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.cppReturnModelData.next(obj);
  }
}
